<template>
  <section class="hbox stretch">
    <div class="content-header">      
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/">运营</a></el-breadcrumb-item>
        <el-breadcrumb-item>商圈列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true">            
        <el-form-item>
          <el-button type="primary" class="el-icon-circle-plus-outline" v-on:click="AddBusinessCircle" >新增</el-button>
        </el-form-item>
        <el-form-item >
          <el-input  placeholder="商圈名称" v-model="name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="Search" >查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="rows" style="width: 100%">
        <el-table-column  fixed  prop="Name"  label="名称" > </el-table-column>
        <el-table-column  prop="Icon" label="图标" width="80" align="center">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.Image"
              placement="left"
              trigger="hover"
            >
              <div>
                <img
                  :src="scope.row.Image"
                  max-width="400"
                  max-height="400"
                >
              </div>  
              <img
                slot="reference"
                :src="scope.row.Image"
                width="20"
                height="20"
              >
            </el-popover> 
            <p v-else>
              --
            </p>
          </template>         
        </el-table-column> 
        <el-table-column  fixed  prop="Description"  label="描述" > </el-table-column>
        <el-table-column  fixed  prop="Address"  label="地址" > </el-table-column>
        <el-table-column  fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button @click.native.prevent="EditBusinessCircle(scope.row.Id)" type="text" size="small">编辑</el-button>
          <el-button @click="DeleteRow(scope.row.Id)" type="text" size="small">&nbsp; 删除</el-button>
        </template>
      </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>      
    <dia v-bind:dialog="dialog" @GetDate="GetDate"></dia>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import dia from './info'
  export default {
    props:{
    },
    data (){
      return {
        name:'',
        pageIndex:1,
        pagesize:10,
        totalCount:10,
        sort:'Id desc',
        rows:[],
        dialog: {
          id:'0',
          title: '',
          isShow:false
        }        
        
      }
    },
    computed:{
    },
    mounted(){
      this.GetDate();
    },
    components:{    
      dia
    },
    methods:{     
      Search:function(){
        this.pageIndex = 1;
        this.GetDate();
      },
      AddBusinessCircle:function(){
        this.dialog.id = '0'
        this.dialog.title = '新增商圈'
        this.dialog.isShow = true
      },
      GetDate:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/BusinessCircle/Index',
          params:{
            name : that.name,
            pageIndex : that.pageIndex,
            pagesize : that.pagesize,
            sort : that.sort
          }
        }).then(function (resp) {
          that.totalCount = resp.data.totalCount
          that.rows = resp.data.data
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      EditBusinessCircle(id){
        this.dialog.id = id
        this.dialog.title = '编辑商圈'
        this.dialog.isShow = true
      },
      handleSizeChange(val) {
        this.pagesize = val
        this.pageIndex = 1
        this.GetDate()
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.GetDate()
      },
      DeleteRow(id) {
        this.$confirm('确定要删除该商圈吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/BusinessCircle/Delete',
            data:{
              id: id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetDate();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      }
    },
    created(){    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
.map
  width: 100%;
  height: 200px;
</style>